import React, { FC, useEffect, useState } from "react";
import {
  Grid,
  Snackbar,
  Box,
  Typography,
  Button,
  Tooltip,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import Alert from "@mui/material/Alert";
import { useDispatch } from "react-redux";
import {
  DataGrid,
  GridLoadingOverlay,
  GridRowSelectionModel,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import { useJogs } from "../../../hooks/jogs";

export interface JogGridRow {
  id: string;
  longName: string;
  shortName: string;
  agencies: string[];
}

const JogAdminGrid: FC = () => {
  // const [rowSelection, setRowSelection] = useState({} as JogGridRow);  
  // const [selectedRows, setSelectedRows] = useState([] as GridRowSelectionModel);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [gridData, setGridData] = useState([] as JogGridRow[]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 25,
    page: 0,
  });
  const dispatch = useDispatch();

  const jogs = useJogs();

  useEffect(() => {
    const rows: JogGridRow[] = jogs.forIncidents.map(jog => {
      return {
        id: jog.id,
        longName: jog.name,
        shortName: jog.shortName,
        agencies: jog.agencies.map(a => {
          return a.shortName
        }).filter(a => !!a)
      }
    });

    setGridData(rows);
  }, [dispatch, jogs.forIncidents]);

  const Toolbar: FC = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
      </GridToolbarContainer>
    );
  }

  const columns = [
    { field: "longName",
      headerName: "Name",
      flex: 1.25,
      maxWidth: 250,
      minWidth: 150,
    },
    { field: "shortName",
      headerName: "Short Name",
      flex: 1,
      maxWidth: 150,
      minWidth: 100,
    },
    {
      field: "agencies",
      headerName: "Agencies",
      flex: 2,
      renderCell: (params: any) => {
        const values = (params.value || []).sort();        
        return values.join(",  ");
      }
    },
  ];

  const getGridHeight = () => {
    const headerHeight = 64;
    const appMainBoxMargins = 16;
    const title = 53;
    const total = headerHeight + appMainBoxMargins + title;
    return `calc(100vh - ${total}px`;
  }

  return (
    <>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          <Tooltip title="JOGs and Agencies currently in the VCC">
            <Typography variant="h6" component="h1">JOGs List</Typography>
          </Tooltip>
        </Grid>
        <Grid item container xs id="admin-grid" alignItems="center" justifyContent="flex-end">
          <Grid item m={1}>
            <Button
              aria-label="Reload Users"
              color="inherit"
              endIcon={<RefreshIcon />}
              //onClick={() => {}} // todo
              style={{ minWidth: "150px" }}
              variant="contained"
            >
              Refresh
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Box style={{ height: getGridHeight() }}>
        <DataGrid
          sx={{
            '& .MuiDataGrid-cell': {
              // If checkboxSelection is ever added to this DataGrid, this top and bottom padding can be deleted.
              // But currently this is used to match the display of the Agency Admin DataGrid
              paddingTop: "15px",
              paddingBottom: "15px",
            },
          }}
          checkboxSelection={false}
          columns={columns}
          disableColumnSelector
          onPaginationModelChange={setPaginationModel}
          //onRowSelectionModelChange={(s) => handleRowSelection(s)}
          paginationModel={paginationModel}
          rows={gridData}
          //rowSelectionModel={selectedRows}
          slots={{
            loadingOverlay: GridLoadingOverlay,
            toolbar: Toolbar,
          }}
          //loading={isLoading}
          getRowHeight={() => 'auto'}
        />
      </Box>

      <Snackbar
        open={errorMessage !== ""}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => setErrorMessage("")}
      >
        <Alert onClose={() => setErrorMessage("")} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        open={successMessage !== ""}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => setSuccessMessage("")}
      >
        <Alert onClose={() => setSuccessMessage("")} severity="success">
          {successMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default JogAdminGrid;
